<template lang="pug">
  .hair-color-browser.xs-mb-100m
    HairColorCompare(v-model="selection")
    HairColorChart(@compare="updateSelection")

</template>

<script>
  import HairColorCompare from '../HairColorCompare';
  import HairColorChart from '../HairColorChart';
  import { mapState, mapGetters, mapActions } from 'vuex';

  export default {
    name: "HairColorBrowser",

    data() {
      return {
        selection: []
      }
    },

    components: {
      HairColorCompare,
      HairColorChart
    },

    methods: {
      updateSelection(product) {
        if (this.selection.length < 4 && !this.selection.includes(product)) {
          this.selection.push(product);
        }
        window.location.hash = '#hair-color-compare';
      }
    }
  }
</script>

<style scoped lang="stylus">
</style>